export default __webpack_public_path__ + "static/media/pexels-karolina-grabowska-5412432-min-min.b83e2f5f.jpg";